import { getConfigValue } from '@jutro/config';
import {
    authTokenHandler,
    HttpRequestBuilder,
    jsonOptions,
} from '@jutro/transport';

function getLanguage() {
    const currentLanguage = localStorage.getItem('selectedLanguage');
    const languageVariant = getConfigValue('localisation.languageVariant');

    if (currentLanguage && languageVariant) {
        return `${currentLanguage}_${languageVariant}`;
    }
    return currentLanguage;
}

/**
 * @memberof module:gw-microapp-util-js
 * @function getRestService
 *
 * @param {string} base The base url of the request
 * @returns {HttpRequest} An authenticated HTTPRequest setup with the baseURL provided
 */

export const getRestService = ({ baseUrl }) => {
    const languageOptions = {
        headers: {
            'Accept-Language': getLanguage(),
        },
    };

    const request = new HttpRequestBuilder(baseUrl)
        .addOptions(jsonOptions)
        .addOptions(languageOptions)
        .addHandler(authTokenHandler);

    const requestService = request.build();
    return requestService;
};
